<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班组名称：</span>
        </div>
        <el-input v-model="formData.groupName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班组类型：</span>
        </div>
        <el-select v-model="formData.type" size="small" style="width: 280px">
          <el-option v-for="item in typeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <b class="red">*</b>
          <span class="line-text">班组人员：</span>
        </div>
        <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入人员姓名" :titles="['未分组人员', '组内人员']" :button-texts="['移除', '加入']" v-model="groupPersonCodes" :data="personList"></el-transfer>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/AttendancePoint'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'attendance-team-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '班组管理'
        }],
        mainTitle: '修改班组',
        subheading: '',

        typeList: [
          {code: '2', name: '排班'},
          {code: '3', name: '免考勤'},
        ],
        personList: [],
        groupPersonCodes: [],
        formData: {
          groupName: '',
          type: '',
          groupPersonCodes: [],
        },
      }
    },
    created () {
      this.getListByUnbound()
    },
    methods: {
      getListByUnbound () {
        this.$axios.post(api.getListByUnbound, {})
          .then(res => {
            let list = res.data.data, personList = []
            list.map(v => {
              v.key = v.code
              v.label = `${v.name} / ${v.deptName}`
              personList.push(v)
            })
            this.personList = personList
            this.getAttendanceGroupByCode()
          })
          .catch(errorHandler('获取人员列表失败'))
      },

      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },

      toManagementPage () {
        this.$router.push({
          name: 'attendance-team-manage'
        })
      },

      // 查询
      getAttendanceGroupByCode () {
        this.$axios.get(`${api.getAttendanceGroupByCode}/${this.$route.params.id}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data, personList = this.personList
              let groupPersonCodes = [], groupMember = data.groupMember || []
              groupMember.map(v => {
                v.key = v.personCode
                v.label = `${v.personName} / ${v.deptName}`
                personList.push(v)
                groupPersonCodes.push(v.personCode)
              })
              this.personList = personList
              this.formData = data
              this.groupPersonCodes = groupPersonCodes
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 修改
      confirm () {
        if (!this.formData.groupName) {
          nError('请输入班组名称')
          return false
        }
        if (this.groupPersonCodes.length === 0) {
          nError('请选择班组人员')
          return false
        }
        this.formData.groupPersonCodes = this.groupPersonCodes
        this.$axios.post(api.updateAttendanceGroup, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('修改失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 600px;
    padding: 0 140px;
    margin: 40px 240px;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceTeam/AttendanceTeamModify.vue